module.exports = __webpack_public_path__ + "img/JINJIANG.ab45c229.png";